import { render, staticRenderFns } from "./somaterilexereport.vue?vue&type=template&id=3fca9df5&scoped=true&"
import script from "./somaterilexereport.vue?vue&type=script&lang=js&"
export * from "./somaterilexereport.vue?vue&type=script&lang=js&"
import style0 from "./somaterilexereport.vue?vue&type=style&index=0&id=3fca9df5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca9df5",
  null
  
)

export default component.exports